import React from "react";
import { useTranslation } from "react-i18next";
import { TableHeader } from "@services/ui-components";
import CreateUpdateClientForm from "./CreateUpdateClientForm";
import { useReactiveVar } from "@apollo/client";
import { useParams } from "react-router-dom";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";

const CreateClient: React.FC = () => {
    const { t } = useTranslation();
    const { branchId } = useParams();
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);

    return (
        <div className="mb-3">
            <TableHeader
                title={t("New Client")}
                paths={[
                    { path: `/clients/${currentCompanyId}/new/${branchId}`, label: t("Customers") },
                    { path: `/clients/${currentCompanyId}/list/${branchId}`, label: t("List of Clients") },
                    { path: `/clients/${currentCompanyId}/new/${branchId}`, label: t("New Client") },
                ]}
                colSize={12}
            />
            <CreateUpdateClientForm />
        </div>
    );
};

export default CreateClient;
